"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.staticCardProperties = void 0;
const CardName_1 = require("../CardName");
const CardType_1 = require("./CardType");
const Units_1 = require("../Units");
const constants_1 = require("../constants");
exports.staticCardProperties = new Map();
class Card {
    constructor(properties) {
        let staticInstance = exports.staticCardProperties.get(properties.name);
        if (staticInstance === undefined) {
            if (properties.cardType === CardType_1.CardType.CORPORATION && properties.startingMegaCredits === undefined) {
                throw new Error('must define startingMegaCredits for corporation cards');
            }
            if (properties.cost === undefined) {
                if ([CardType_1.CardType.CORPORATION, CardType_1.CardType.PRELUDE, CardType_1.CardType.STANDARD_ACTION, CardType_1.CardType.LEADER].includes(properties.cardType) === false) {
                    throw new Error(`${properties.name} must have a cost property`);
                }
            }
            exports.staticCardProperties.set(properties.name, properties);
            staticInstance = properties;
        }
        this.properties = staticInstance;
    }
    get adjacencyBonus() {
        return this.properties.adjacencyBonus;
    }
    get cardCost() {
        return this.properties.cardCost;
    }
    get cardType() {
        return this.properties.cardType;
    }
    get cost() {
        return this.properties.cost === undefined ? 0 : this.properties.cost;
    }
    get initialActionText() {
        return this.properties.initialActionText;
    }
    set initialActionText(value) {
        this.properties.initialActionText = value;
    }
    get metadata() {
        return this.properties.metadata;
    }
    get requirements() {
        return this.properties.requirements;
    }
    get name() {
        return this.properties.name;
    }
    get resourceType() {
        return this.properties.resourceType;
    }
    get startingMegaCredits() {
        return this.properties.startingMegaCredits === undefined ? 0 : this.properties.startingMegaCredits;
    }
    get tags() {
        return this.properties.tags === undefined ? [] : this.properties.tags;
    }
    get productionBox() {
        return this.properties.productionBox || Units_1.Units.EMPTY;
    }
    get cardDiscount() {
        return this.properties.cardDiscount;
    }
    get reserveUnits() {
        return this.properties.reserveUnits || Units_1.Units.EMPTY;
    }
    set reserveUnits(value) {
        this.properties.reserveUnits = value;
    }
    get tr() {
        return this.properties.tr || {};
    }
    canPlay(player) {
        if (this.properties.requirements === undefined) {
            return true;
        }
        return this.properties.requirements.satisfies(player);
    }
    static setRedsWarningText(player, trGain, card, upto = false, actionText = 'play this card') {
        if (trGain > 0 && player.cardIsInEffect(CardName_1.CardName.ZAN) === false) {
            const redsCost = trGain * constants_1.REDS_RULING_POLICY_COST;
            if (upto === true) {
                card.warning = `You will lose up to an additional ${redsCost} M€ if you ${actionText} this generation.`;
            }
            else {
                card.warning = `You will lose an additional ${redsCost} M€ if you ${actionText} this generation.`;
            }
        }
        else {
            card.warning = undefined;
        }
    }
    static setRedsActionWarningText(player, trGain, card, redsAreRuling, actionText = 'take this action', uncertain = false) {
        if (trGain > 0 && redsAreRuling && player.cardIsInEffect(CardName_1.CardName.ZAN) === false) {
            const redsCost = trGain * constants_1.REDS_RULING_POLICY_COST;
            const modifier = uncertain ? 'may lose some extra' : `will lose an additional ${redsCost}`;
            card.warning = `You ${modifier} M€ if you ${actionText} this generation.`;
        }
        else {
            card.warning = undefined;
        }
    }
    static setUselessActionWarningText(card, reason) {
        card.warning = `This action may have no benefit as ${reason}.`;
    }
    static setSocietyWarningText(card, partyName) {
        if (card.warning === undefined) {
            card.warning = `This card will cost an extra ${constants_1.SOCIETY_ADDITIONAL_CARD_COST} M€ as ${partyName} party is not in play.`;
        }
        else {
            card.warning += ` This card will cost an extra ${constants_1.SOCIETY_ADDITIONAL_CARD_COST} M€ as ${partyName} party is not in play.`;
        }
    }
    static setProductionDecreaseWarningText(card, resource, canTargetOthers) {
        if (canTargetOthers === false) {
            card.warning = `You will have to decrease your own ${resource} production if you play this card now.`;
        }
        else {
            card.warning = undefined;
        }
    }
    static setCannotAffordWarningText(card, player, qty = 1) {
        if (!player.canAfford(player.cardCost * qty)) {
            card.warning = `You will not be able to buy ${qty} card(s) if you take this action now.`;
        }
        else {
            card.warning = undefined;
        }
    }
    static setUnplayablePreludeWarningText(card, player) {
        if ((card.canPlay === undefined || card.canPlay(player)) === false) {
            card.warning = "This prelude will be discarded for 15 M€ if you play it now.";
        }
        else {
            card.warning = undefined;
        }
    }
}
exports.Card = Card;
//# sourceMappingURL=Card.js.map